<template>
  <draggable
    v-model="pages"
    tag="tbody"
    @start="drag = true"
    @end="sortPages"
    >
      <slot />
  </draggable>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import apiClient from '@/services/axios'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  data: () => ({
    drag: false,
  }),
  computed: {
    ...mapFields('event', {
      event: 'event',
      pages: 'pagesArray',
      sortUpdate: 'sortUpdate',
    }),
  },
  methods: {
    async sortPages() {
      const pagesSort = this.pages.map((page, index) => {
        return {
          page_id: page.id,
          sort: index + 1,
        }
      })
      const sort = { sort: pagesSort }
      const url = '/admin/events/pages/sort'
      try {
        await apiClient.patch(url, sort)
        this.sortUpdate = true
      } catch (error) {
        console.log('Error while sorting pages', error)
      } finally {
        this.drag = false
      }
    },
  },
}
</script>
